export default __webpack_public_path__ + "static/biohazard_b.48c066fc75ff9982077d9a9fdd4ee0f2.png";